import Map, { Marker } from './Map';

export default Map;
export { Marker };
